// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"eb4150cd576cf23f81a5","777":"242e19325a3206b9a863"}[chunkId] + ".js";
};